import { useQuery } from "@tanstack/react-query";
import { getSevenRoomsStatus } from "../../api/bSevenroomsApi";

export const useGetSevenRoomsStatus = (organisationId, enabled = true) => {
  return useQuery({
    queryKey: ["sevenrooms-status", organisationId],
    queryFn: () => getSevenRoomsStatus(organisationId),
    enabled: !!organisationId && enabled,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: true,
    onError: (error) => {
      console.error("Error fetching SevenRooms status:", error.response || error);
    },
  });
};
